import { render, staticRenderFns } from "./YouLive.vue?vue&type=template&id=483578e7"
import script from "./YouLive.vue?vue&type=script&lang=js"
export * from "./YouLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports